import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCta() {
  const {
    t
  } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const contact = document.getElementById('contacto');
      const scrollY = window.scrollY;
      const showAfter = 600;
      const hideBefore = contact ? contact.offsetTop - 600 : Infinity;
      setIsVisible(scrollY > showAfter && scrollY < hideBefore);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-373" data-mp="1cxo6o53repui">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.5,
      ease: [0.33, 1, 0.68, 1]
    }} className="lg:hidden fixed bottom-6 left-6 right-6 z-40" data-id="element-374" data-mp="18u8b7c3fevje">
          <button onClick={scrollToContact} className="w-full bg-brand-dark/95 backdrop-blur-md text-brand-cream rounded-full shadow-2xl px-6 py-4 flex items-center justify-between active:scale-[0.98] transition-transform border border-brand-gold/30" data-id="element-375" data-mp="16fyxc492osho">
            <span className="text-xs font-semibold tracking-[0.15em] uppercase text-brand-cream" data-id="element-376" data-mp="isqtlqralrhr">
              {t('stickyCta.text')}
            </span>
            <span className="flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-brand-gold" data-id="element-377" data-mp="nofv3zmvhigp">
              {t('stickyCta.button')}
              <span data-id="element-378" data-mp="eosu3ey22eo6">→</span>
            </span>
          </button>
        </motion.div>}
    </AnimatePresence>;
}